import {createRouter, createWebHashHistory} from 'vue-router';

import Login from './pages/public/Login.vue';
import AnonLayout from './layouts/AnonLayout';
import AuthedLayout from './layouts/AuthedLayout';
import Config from './config';
import Procedures from './pages/Procedures';
import ProcedureCreate from './pages/ProcedureCreate';
import ProcedureView from './pages/ProcedureView';
import ProcedureApplication from './pages/ProcedureApplication';
import ProcedureReview from './pages/ProcedureReview';
import ProcedureSumming from './pages/ProcedureSumming';
import ProcedureCompleted from './pages/ProcedureCompleted';
import Contragents from './pages/admin/Сontragents';
import Contragent from '@/pages/admin/Contragent';
import Users from './pages/admin/Users';
import User from './pages/admin/User';
import ProfileUser from './pages/ProfileUser';
import ProfileContragent from './pages/ProfileContragent';
import Register from './pages/public/Register';
import NotificationsTable from './pages/NotificationsTable.vue';
import DaDataFeature from "@/components/features/DaDataFeature.vue";
import Configs from "@/pages/admin/Configs.vue";
import Nds from './pages/admin/Nds.vue';
import AllProcedureApplications from "@/pages/AllProcedureApplications.vue";
import Categories from '@/pages/admin/Categories.vue';
import ApiIntegration from "@/pages/admin/ApiIntegration.vue";
import PublicProcedures from "@/pages/public/PublicProcedures.vue";
import ApiEvents from './pages/admin/ApiEvents/ApiEvents.vue';
import LogEvents from '@/pages/admin/LogEvents.vue';
import i18n from "@/plugins/i18n"

const menu = [
  {
    name: 'Процедуры',
    path: '/procedures',
    icon: 'file-document-multiple-outline',
    requireAccreditation: true
  },
  {
    name: 'Процедуры',
    path: '/public/procedures',
    icon: 'file-document-multiple-outline',
    requireAccreditation: false,
    targetBlank: true
  }
];

const customerMenu = [
  {
    name: 'Процедуры',
    path: '/procedures',
    icon: 'file-document-multiple-outline',
  },
  {
    name: 'Пользователи',
    path: '/users',
    icon: 'file-document-multiple-outline',
    accesses: ['view_users_org', 'view_users_supplier'],
  },
]

const adminMenu = [
  {
    name: 'Процедуры',
    path: '/procedures',
    icon: 'file-document-multiple-outline',
  },
  {
    name: 'Организации',
    path: '/admin/contragents/all',
    icon: 'office-building-outline'
  },
  {
    name: 'Пользователи',
    path: '/admin/users',
    icon: 'account',
  },
  {
    name: 'Администрирование',
    path: '/admin/administration',
    children: [
      {
        name: 'Почтовые уведомления',
        path: '/admin/administration/mails'
      },
      {
        name: 'События',
        path: '/admin/administration/events'
      },
      {
        name: 'События API',
        path: '/admin/administration/api-events'
      },
      {
        name: 'Конфигурации',
        path: '/admin/administration/configs'
      },
      {
        name: 'Настройки системы',
        path: '/admin/administration/features',
        children: [
          {
            name: 'Интеграция с DaData',
            path: '/admin/administration/features/da-data',
          },
          {
            name: 'Справочник НДС',
            path: '/admin/administration/features/nds'
          },
          {
            name: 'Интеграция API',
            path: '/admin/administration/features/api-integration'
          },
          {
            name: 'Категории поставщиков',
            path: '/admin/administration/features/categories'
          }
        ]
      }
    ]
  }
];

const adminRoutes = {
  component: AuthedLayout,
  path: '/admin',
  name: 'admin-parent',
  meta: {
    allowedRoles: ['ROLE_ADMIN'],
    redirectForbiddenTo: (user) => `/procedures`
  },
  children: [
    {
      path: '/admin/procedures',
      name: 'admin.procedures.all',
      component: Procedures,
      meta: {
        title: 'Все процедуры',
        requiresAuth: true,
      },
    },
    {
      path: '/admin/contragents/all',
      name: 'admin.contragents.all',
      component: Contragents,
      meta: {
        title: 'Все организации',
        requiresAuth: true,
      },
    },
    {
      path: '/admin/contragents/:id/view',
      name: 'admin.contragents.view',
      component: Contragent,
      meta: {
        title: 'Сведения об организации',
        requiresAuth: true,
      },
    },
    {
      path: '/admin/contragents/create',
      name: 'admin.contragents.create',
      component: Contragent,
      meta: {
        title: 'Создание организации',
        requiresAuth: true
      },
    },
    {
      path: '/admin/contragents/:id/edit',
      name: 'admin.contragents.edit',
      component: Contragent,
      meta: {
        title: 'Редактирование организации',
        requiresAuth: true
      }
    },
    {
      path: '/admin/users',
      name: 'users.all',
      component: Users,
      meta: {
        title: 'Все пользователи',
        requiresAuth: true,
      },
    },
    {
      path: '/admin/users/:id/view',
      name: 'admin.users.view',
      component: User,
      props: route => ({
        userId: route.params.id
      }),
      meta: {
        title: 'Сведения о пользователе',
        requiresAuth: true,
      },
    },
    {
      path: '/admin/users/create',
      name: 'admin.users.create',
      component: User,
      meta: {
        title: 'Создание пользователя',
        requiresAuth: true
      },
    },
    {
      path: '/admin/users/:id/edit',
      name: 'admin.users.edit',
      component: User,
      props: route => ({
        userId: route.params.id
      }),
      meta: {
        title: 'Редактирование пользователя',
        requiresAuth: true
      }
    },
    {
      path: '/admin/administration/events',
      name: 'admin.administration.events',
      component: LogEvents,
      meta: {
        title: 'Cобытия',
        requiresAuth: true
      }
    },
    {
      path: '/admin/administration/api-events',
      name: 'admin.administration.api-events',
      component: ApiEvents,
      meta: {
        title: 'События API',
        requiresAuth: true
      }
    },
    {
      path: '/admin/administration/features/nds',
      name: 'admin.administration.features.nds',
      component: Nds,
      meta: {
        title: 'Справочник НДС',
        requiresAuth: true
      }
    },
    {
      path: '/admin/administration/features/api-integration',
      name: 'admin.administration.features.api-integration',
      component: ApiIntegration,
      meta: {
        title: 'Интеграция API',
        requiresAuth: true
      }
    },
    {
      path: '/admin/administration/configs',
      name: 'admin.administration.configs',
      component: Configs,
      meta: {
        title: 'Конфигурации',
        allowedRoles: ['ROLE_ADMIN'],
        redirectForbiddenTo: () => `/procedures`,
        requiresAuth: true
      }
    },
    {
      path: '/admin/administration/mails',
      name: 'admin.administration.mails',
      component: NotificationsTable,
      meta: {
        title: 'Почтовые уведомления',
        requiresAuth: true
      }
    },
    {
      path: '/admin/administration/features/da-data',
      name: 'admin.administration.features.da-data',
      component: DaDataFeature,
      meta: {
        title: 'Настройки системы',
        requiresAuth: true
      }
    },
    {
      path: '/admin/administration/features/categories',
      name: 'admin.administration.features.categories',
      component: Categories,
      meta: {
        title: 'Категории поставщиков',
        requiresAuth: true
      }
    }
  ]
};

/**
 * Роуты под профиль
 */
const profileRoutes = {
  component: AuthedLayout,
  name: 'profile-parent',
  path: '/profile',
  children: [
    {
      path: '/profile/user',
      name: 'profile.user',
      component: ProfileUser,
      meta: {
        title: 'Профиль пользователя',
        requiresAuth: true,
      },
    },
    {
      path: '/profile/contragent/:id',
      name: 'profile.contragent.view',
      component: ProfileContragent,
      props: route => ({
        contragentId: route.params.id
      }),
      meta: {
        title: 'Профиль организации',
        requiresAuth: true,
        allowedRoles: ['ROLE_ADMIN'],
        redirectForbiddenTo: () => `/profile/contragent`,
      },
    },
    {
      path: '/profile/contragent',
      name: 'profile.contragent',
      component: ProfileContragent,
      meta: {
        title: 'Профиль организации',
        requiresAuth: true,
      },
    },
    {
      path: '/profile/mails',
      name: 'profile.mails',
      component: NotificationsTable,
      meta: {
        title: 'Почтовые уведомления',
        requiresAuth: true,
      },
    }
  ],
};

/**
 * Роуты под компонент с авторизированным доступом
 */
const protectedRoute = {
  path: '/',
  name: 'procedures-parent',
  component: AuthedLayout,
  meta: {
    title: 'Процедуры',
  },
  redirect: () => {
    return Config.isGuest() ? '/public/procedures' : '/procedures';
  },
  guestRedirect: '/public/procedures',
  children: [
    {
      path: '/public/procedures/:id',
      name: 'public.procedures.view',
      component: ProcedureView,
      meta: {
        title: 'Просмотр процедуры',
        requiresAuth: false,
      },
    },
    {
      path: '/public/procedures',
      name: 'public.procedures',
      component: PublicProcedures,
      meta: {
        title: 'Все процедуры',
        requiresAuth: false,
      },
    },
    {
      path: '/procedures',
      name: 'procedures.all',
      component: Procedures,
      meta: {
        title: 'Все процедуры',
        requiresAuth: true,
      },
    },
    {
      path: '/procedures/:id/publish',
      name: 'procedures.publish',
      component: ProcedureCreate,
      meta: {
        title: 'Публикация процедуры',
        requiresAuth: true,
      },
    },
    {
      path: '/procedures/:id/edit',
      name: 'procedures.edit',
      component: ProcedureCreate,
      meta: {
        title: 'Редактирование процедуры',
        requiresAuth: true,
      },
    },
    {
      path: '/procedures/:id/view',
      name: 'procedures.view',
      component: ProcedureView,
      meta: {
        title: 'Просмотр процедуры',
        requiresAuth: true,
      },
    },
    {
      path: '/procedures/:id/applications',
      name: 'procedures.viewApps',
      component: AllProcedureApplications,
      meta: {
        title: 'Поданные заявки',
        requiresAuth: true
      }
    },
    {
      path: '/procedures/:id/review',
      name: 'procedures.review',
      component: ProcedureReview,
      meta: {
        title: 'Рассмотрение заявок по процедуре',
        requiresAuth: true,
      },
    },
    {
      path: '/procedures/:id/summarize',
      name: 'procedures.summarize',
      component: ProcedureSumming,
      meta: {
        title: 'Подведение итогов по процедуре',
        requiresAuth: true,
      },
    },
    {
      path: '/procedures/:id/completed',
      name: 'procedures.completed',
      component: ProcedureCompleted,
      meta: {
        title: 'Завершена',
        requiresAuth: true,
      },
    },
    {
      path: '/applications/procedure/:procedureId',
      name: 'applications.procedure',
      component: ProcedureApplication,
      props: route => ({
        procedureId: route.params.procedureId,
        mode: 'EDIT'
      }),
      meta: {
        title: 'Заявка на процедуру',
        requiresAuth: true,
      },
    },
    {
      path: '/application/:applicationId/procedure/:procedureId/edit_draft',
      name: 'application.procedure.edit_draft',
      component: ProcedureApplication,
      props: route => ({
        applicationId: route.params.applicationId,
        procedureId: route.params.procedureId,
        mode: 'EDIT'
      }),
      meta: {
        title: 'Заявка на процедуру',
        requiresAuth: true
      }
    },
    {
      path: '/application/:applicationId/procedure/:procedureId/edit',
      name: 'application.procedure.edit',
      component: ProcedureApplication,
      props: route => ({
        applicationId: route.params.applicationId,
        procedureId: route.params.procedureId,
        mode: 'EDIT'
      }),
      meta: {
        title: 'Редактирование заявки на процедуру',
        requiresAuth: true
      }
    },
    {
      path: '/application/:applicationId/procedure/:procedureId/view',
      name: 'application.procedure.view',
      component: ProcedureApplication,
      props: route => ({
        applicationId: route.params.applicationId,
        procedureId: route.params.procedureId,
        mode: 'VIEW'
      }),
      meta: {
        title: 'Просмотр заявки',
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        title: 'Пользователи организации',
        requiresAuth: true,
      },

    },
    {
      path: '/users/create',
      name: 'users.create',
      component: User,
      meta: {
        title: 'Создание пользователя организации',
        requiresAuth: true
      },
    },
    {
      path: '/users/:id/view',
      name: 'users.view',
      component: User,
      props: route => ({
        userId: route.params.id
      }),
      meta: {
        title: 'Сведения о пользователе организации',
        requiresAuth: true,
      },
    },
    {
      path: '/users/:id/edit',
      name: 'users.edit',
      component: User,
      props: route => ({
        userId: route.params.id
      }),
      meta: {
        title: 'Редактирование пользователя организации',
        requiresAuth: true
      }
    },
  ]
};

/**
 * Роуты под компонент с анонимным доступом.
 * Без меню и информации о пользователе.
 */
const publicRoute = {
  path: '/auth',
  name: 'auth-parent',
  component: AnonLayout,
  children: [
    {
      path: '/auth/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auth/register',
      name: 'register',
      component: Register,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auth/sendResetPasswordLink',
      name: 'sendResetPasswordLink',
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auth/resetPassword/:hash?',
      name: 'resetPassword',
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
  ],
};

/**
 * Перевести роутеры
 */
function transleteRoutes(routes, isNeedTranslateName = true) {
  routes.forEach(route => {
    if (isNeedTranslateName) {
      route.name = i18n.global.t(route.name)
    }
    if (route.meta?.title !== undefined) {
      route.meta.title = i18n.global.t(route.meta.title)
    }
    if (Array.isArray(route.children ?? null)) {
      transleteRoutes(route.children)
    }
  })
}

function makeRouter() {
  const routes = [protectedRoute, publicRoute, adminRoutes, profileRoutes]
  routes.forEach(route => {
    transleteRoutes([route], false)
  })
  const router = createRouter({
    history: createWebHashHistory(),
    routes,
  });

  router.beforeEach((to, from, next) => {
    if (to.matched.some((route) => route.meta.requiresAuth)) {
      const user = Config.get('user');

      if (!user) {
        sessionStorage.setItem('redirectUrlAfterLogin', to.fullPath);
        next({
          path: '/auth/login',
        });
      } else {
        const routeWithRoles = to.matched.find(route => route.meta.allowedRoles);
        if (routeWithRoles) {
          const hasAccess = routeWithRoles.meta.allowedRoles.some(role => user.roles.includes(role));
          if (!hasAccess) {
            return next({path: routeWithRoles.meta.redirectForbiddenTo(user)});
          } else {
            return next()
          }
        } else {
          return next()
        }
      }
    } else {
      next();
    }
  });

  return router;
}

/**
 *
 * @param {User} user
 */
function makeMenu(user) {
  let tmpMenu = null;
  if (user.hasRole('ROLE_ADMIN')) {
    tmpMenu = adminMenu;
  } else {
    let hasAllAccesses = false;

    customerMenu.forEach(item => {
      if (item.accesses) {
        hasAllAccesses = item.accesses.some(access => user.hasAccess(access));
      }
    })

    tmpMenu = hasAllAccesses ? customerMenu : menu;
  }
  transleteRoutes(tmpMenu)

  return tmpMenu;
}

export {makeRouter, makeMenu, transleteRoutes};
